import { Link } from 'react-router-dom';
import './OtherProducts.css';
import { Helmet } from 'react-helmet-async';


const heroImg = "/images/abouthero.webp";

const OTHER_PRODUCTS = [
  { 
    id: 1,
    name: " Vighnaharta Masala Dhoop Sticks",
    price: "₹35/- 12pcs Sticks",
    img: "/images/pro1.webp",
    badgeColor: "#1b7a3e"
  },
  {
    id: 2,
    name: "Sandalwood Masala Dhoop Sticks",
    price: "₹35-12pcs Sticks",
    img: "/images/pro2.webp",
    badgeColor: "#c03a2b"
  },
  {
    id: 3,
    name: " Mysore Garden Masala Dhoop Sticks",
    price: "₹25-15pcs Sticks",
    img: "/images/pro3.webp",
    badgeColor: "#0b1f4b"
  },
  {
    id: 4,
    name: "Fancy Flora Masala Dhoop Sticks",
    price: "₹25- 15pcs Sticks",
    img: "/images/pro4.webp",
    badgeColor: "#8d4a1a"
  },
  {
    id: 5,
    name: "Shiva Shakti Dhoop Cone",
    price: "₹25-15pcs Sticks",
    img: "/images/pro5.webp",
    badgeColor: "#b5860d"
  },
  {
    id: 6,
    name: "Prayag Dhoop Cone",
    price: "₹35- 20pcs Cones",
    img: "/images/pro6.webp",
    badgeColor: "#5a3a1a"
  },
  
     {
    id: 9,
    name: "Pure Chandan",
    price: " ₹32/20grams, ₹60/50grams",
    img: "/images/pro9.webp",
    badgeColor: "#555"
  },
     {
    id: 10,
    name: "Kesar Asthagandha",
    price: "₹32/25grams, ₹60/60grams",
    img: "/images/pro10.webp",
    badgeColor: "#555"
  },
  {
    id: 7,
    name: "Shitalambari Shining Powder",
    price: "₹145/-200 grams",
    img: "/images/pro7.webp",
    badgeColor: "#555"
  },

    {
    id: 8,
    name: "Shitalambari Liquid",
    price: " 130/- 130 ml",
    img: "/images/pro8.webp",
    badgeColor: "#555"
  },

  
];
export default function OtherProducts() {
  return (
    <main className="op-page">
<Helmet>
        <title>Other Sacred Products | Dhoop Sticks, Dhoop Cones & Puja Essentials — Prakhyat</title>
        <meta
          name="description"
          content="Shop Prakhyat's other sacred puja products — Masala Dhoop Sticks, Dhoop Cones, Pure Chandan, Kesar Asthagandha, Shitalambari Powder & Liquid. Pure Vedic essentials for daily puja & spiritual practice. WhatsApp enquiry available."
        />
        <meta
          name="keywords"
          content="dhoop sticks, masala dhoop sticks, sandalwood dhoop sticks, dhoop cone, shiva shakti dhoop cone, pure chandan powder, kesar asthagandha, shitalambari powder, shitalambari liquid, puja essentials india, vedic puja products, prakhyat other products, vighnaharta dhoop stick, mysore garden dhoop stick"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://prakhyatagarbatti.com/products/other" />
      </Helmet>
      {/* HERO */}
      <section className="op-hero">
        <div className="op-hero__bg" style={{ backgroundImage:`url('${heroImg}')` }} />
        <div className="op-hero__overlay" />
        <div className="op-hero__content">
          {/* <span className="op-hero__icon">🪔</span> */}
          <h1 className="op-hero__title">Other Sacred Products</h1>
          <p className="op-hero__sub">Pure Vedic essentials for your daily puja &amp; spiritual practice</p>
        </div>
        <div className="op-hero__bar" />
      </section>

      {/* GRID */}
      <section className="op-section">
        <div className="op-wrap">
          <div className="op-grid">
            {OTHER_PRODUCTS.map((p, i) => (
              <div key={p.id} className="op-card" style={{ animationDelay:`${i*0.06}s` }}>
                <div className="op-card__img-wrap">
                  <img src={p.img} alt={p.name} loading={i < 8 ? "eager" : "lazy"} className="op-card__img" />
                  <span className="op-card__badge" style={{ background:p.badgeColor }}>{p.badge}</span>
                  <span className="op-card__price">{p.price}</span>
                </div>
                <div className="op-card__body">
                  <p className="op-card__num">#{String(p.id).padStart(2,'0')}</p>
                  <h3 className="op-card__name">{p.name}</h3>
                  <a
                    href={`https://wa.me/919320905751?text=${encodeURIComponent(`Hi, I want to enquire about ${p.name}`)}`}
                    className="op-card__enquiry"
                    target="_blank"
                    rel="noreferrer"
                  >
                    💬 WhatsApp Enquiry
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="op-cta">
        <div className="op-wrap">
          <div className="op-cta__inner">
            <div>
              <h3 className="op-cta__title">Need Customized or Bulk supply Agarbattis</h3>
              <p className="op-cta__sub">We supply customized products as per choice for Exports, Institutions, Temples, Corporates, etc on a Volume base pricing</p>
            </div>
            <div className="op-cta__btns">
              <Link to="/contact" className="op-cta__btn op-cta__btn--gold">📦 Contact Us</Link>
              <a href="https://wa.me/919320905751" className="op-cta__btn op-cta__btn--wa" target="_blank" rel="noreferrer">💬 WhatsApp</a>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
